/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: index.ts
 * Project: mle-client-n
 * Committed last: 2022/1/16 @ 1231
 * ---
 * Description:
 */

import { ShapeTypes } from '../../../common/enums';

export const shapeTypesWithCustomDataPanel = [ShapeTypes.TABLE, ShapeTypes.RICH_TEXT, ShapeTypes.IMAGE];